;
export var ApiParameterType;
(function (ApiParameterType) {
    ApiParameterType["String"] = "string";
    ApiParameterType["Number"] = "number";
    ApiParameterType["Datetime"] = "datetime";
    ApiParameterType["Boolean"] = "boolean";
    ApiParameterType["Binary"] = "binary";
    ApiParameterType["Object"] = "object";
})(ApiParameterType || (ApiParameterType = {}));
export class ApiParserBase {
    async load(url, headers) {
        let resp = await fetch(url, {
            mode: 'cors', credentials: 'omit', headers: headers
        });
        try {
            let json = await resp.json();
            return this.parse(json, url);
        }
        catch (e) {
            return null;
        }
    }
}
const $refPattern = /^#\/(definitions|components\/schemas)\/(.+)$/;
export function getOpenApiDefinition(manifest, $ref) {
    var rec = $refPattern.exec($ref);
    if (rec && rec.length > 2) {
        return { name: rec[2], schema: manifest.definitions[rec[2]] };
    }
    return null;
}
//}
